// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getProfile } from "../features/user";
// ** UseJWT import to get config
import useJwt from "@src/auth/jwt/useJwt";
import { logout } from "@features/auth/api/logout";

const config = useJwt.jwtConfig;

export const fetchProfile = createAsyncThunk("auth/fetchProfile", async () => {
  const response = await getProfile();
  if (response.data.id) {
    return response.data;
  } else {
    return {
      // profile: response[0],
    };
  }
});

const initialUser = () => {
  const item = window.localStorage.getItem("userData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    userData: initialUser(),
  },
  reducers: {
    handleLogin: (state, action) => {
      // localStorage.setItem(
      //   config.storageTokenKeyName,
      //   action.payload.accessToken
      // );
      // localStorage.setItem(
      //   config.storageRefreshTokenKeyName,
      //   action.payload.refreshToken
      // );
      state[config.storageTokenKeyName] = action.payload.accessToken;
      state[config.storageRefreshTokenKeyName] = action.payload.refreshToken;
      // localStorage.setItem("userData", JSON.stringify(action.payload)); // Ensure you persist the data

      localStorage.setItem(
        config.storageTokenKeyName,
        action.payload.accessToken
      );
      localStorage.setItem(
        config.storageRefreshTokenKeyName,
        action.payload.refreshToken
      );
    },
    handleSetUser: (state, action) => {
      state.userData = action.payload;
      state[config.storageTokenKeyName] =
        action.payload[config.storageTokenKeyName];
      state[config.storageRefreshTokenKeyName] =
        action.payload[config.storageRefreshTokenKeyName];
      localStorage.setItem("userData", JSON.stringify(action.payload));
    },
    handleLogout: (state) => {
      // const { navigate } = action.payload;
      state.userData = {};
      state[config.storageTokenKeyName] = null;
      state[config.storageRefreshTokenKeyName] = null;
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem("userData");
      localStorage.removeItem(config.storageTokenKeyName);
      localStorage.removeItem(config.storageRefreshTokenKeyName);

      // await logout();

      // window.location.href = "/signin";
      // navigate("/signin");
    },
    handleUpdateUser: (state, action) => {
      state.userData = { ...state.userData, ...action.payload };
      localStorage.setItem(
        "userData",
        JSON.stringify({ ...state.userData, ...action.payload })
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProfile.fulfilled, (state, action) => {
      state.userData = { ...state.userData, ...action.payload };
    });
  },
});

export const { handleLogin, handleLogout, handleSetUser, handleUpdateUser } =
  authSlice.actions;
export default authSlice.reducer;
